export default __webpack_public_path__ + "static/media/screen_viber_3.e32529ad.png";